import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import { isFundingBlind } from '../../../../utils/fundings';

function FundingBlindCollectionForm({
  fundingStatus,
  fundingRepaymentMode,
  consumerBankAccountStatus,
}) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Blind Collection:</Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Badge
          className="bo-badge"
          bg={
            isFundingBlind(fundingStatus, fundingRepaymentMode, consumerBankAccountStatus)
              ? 'danger'
              : 'success'
          }
        >
          {isFundingBlind(fundingStatus, fundingRepaymentMode, consumerBankAccountStatus)
            ? 'Yes'
            : 'No'}
        </Badge>
      </Col>
      <Col md={2} className="bo-same-line" />
    </>
  );
}

export default memo(FundingBlindCollectionForm);
